module.exports = __webpack_public_path__ + "static/media/fire.b64fb407.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fire.svg
// module id = 2384
// module chunks = 7